import React from 'react';
import Avatar from 'material-ui/Avatar';
import Doctor from 'material-ui/svg-icons/maps/local-hospital';
import Messages from 'material-ui/svg-icons/communication/email';
import ContactCareGuide from 'material-ui/svg-icons/communication/forum';
import HelpIcon from 'material-ui/svg-icons/communication/live-help';
import Face from 'material-ui/svg-icons/action/face';
import Dollar from 'material-ui/svg-icons/editor/monetization-on';
import InsuraceCard from 'material-ui/svg-icons/av/subtitles';
import MyBenefits from 'material-ui/svg-icons/action/view-list';
import SearchIcon from 'material-ui/svg-icons/action/search';
import Folder from 'material-ui/svg-icons/file/folder';
import Chat from 'material-ui/svg-icons/action/question-answer';
import Rate from 'material-ui/svg-icons/toggle/star';
import Bill from 'material-ui/svg-icons/action/description';
import LabOrTest from 'material-ui/svg-icons/action/accessibility';


export default class IconRender extends React.Component {

    
    renderIconOld = (mod) => {
        if(mod.NewIcon)
            return <div><i className={mod.NewIcon}></i></div>;
        else{
            switch(mod.Icon){
                case "message":
                    return <Messages />;
                case "live_help":
                    return <HelpIcon />;
                case "search":
                    return <SearchIcon />;
                case "face":
                    return <Face />;
                case "subtitles":
                    return <InsuraceCard />;
                case "view_list":
                case "benefits":
                    return <MyBenefits />;
                case "monetization_on":
                    return <Dollar />;
                case "attach_money":
                    return <Dollar />;
                case "forum":
                    return <ContactCareGuide />;
                case "documents":
                    return <Folder />;
                case "question_answer":
                    return <Chat />;
                case "doctor":
                    return <Doctor />;
                case "rate_app":
                    return <Rate />;
                case "lab_or_test":
                    return <LabOrTest />;
                case "bill":
                    return <Bill />;
            }
        }
    }

    renderIconNew = (mod) => {
        return <div><i className={mod.NewIcon}></i></div>;
      
    }

    renderIcon = (mod) => {
    
    if(mod.NewIcon) {
        var iconNew = this.renderIconNew(mod);
        return (
        <Avatar  
            backgroundColor={window.muiTheme.palette.secondary1Color || window.muiTheme.palette.primary1Color} 
        >
            {iconNew}
        </Avatar>
        )
    }
    else{

        var icon = this.renderIconOld(mod);
        return (
        <Avatar 
            icon={icon}
            backgroundColor={window.muiTheme.palette.secondary1Color || window.muiTheme.palette.primary1Color} 
        />
        )
    }
    
    }
    
  render() {

    return (
         <div>
            {this.props.icon && this.renderIcon(this.props.icon)}
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/IconRender.js